<div [className]="'mainBody All'">
    <router-outlet></router-outlet>
</div>